module.exports = __webpack_public_path__ + "static/ver2/img/logo_short_white.127216f7.png";